/**
 * Foundation/UI — azione di copia volontaria da un campo sorgente a un campo destinazione.
 *
 * Principi Foundation (M-UX-01): nessuna copia automatica; il link compare solo se
 * la sorgente è valorizzata (e compatibile) e la destinazione è vuota; al clic copia,
 * lascia il focus sulla destinazione e mostra un breve feedback.
 * Esempi Suite: Sede operativa ← Sede legale, PEC amministrativa ← PEC azienda,
 * Telefono ← Cellulare, Referente ← Legale rappresentante.
 */
import React, { useEffect, useState } from "react";
import { Check, CornerDownRight } from "lucide-react";

export function CopyFromFieldAction({
  sourceValue,
  targetValue,
  onCopy,
  targetRef,
  sourceLabel,
  copiedMessage,
  isCompatible = () => true,
  transform = (v) => v,
  testIdPrefix = "copy-from-field",
}) {
  const [copied, setCopied] = useState(false);
  const source = (sourceValue || "").trim();
  const targetEmpty = !(targetValue || "").trim();

  useEffect(() => {
    if (targetEmpty) setCopied(false);
  }, [targetEmpty]);

  if (copied && !targetEmpty) {
    return (
      <div className="mt-1 flex items-center gap-1 text-xs text-emerald-700" role="status" data-testid={`${testIdPrefix}-feedback`}>
        <Check size={12} /> {copiedMessage}
      </div>
    );
  }
  if (!source || !targetEmpty || !isCompatible(source)) return null;

  const handleClick = () => {
    onCopy(transform(source));
    setCopied(true);
    requestAnimationFrame(() => targetRef?.current?.focus());
  };

  return (
    <button
      type="button"
      onMouseDown={(e) => e.preventDefault()}
      onClick={handleClick}
      className="mt-1 inline-flex items-center gap-1 text-xs text-suite-primary underline-offset-2 transition-colors hover:underline focus-visible:underline focus-visible:outline-none"
      data-testid={`${testIdPrefix}-link`}
    >
      <CornerDownRight size={12} /> Copia dal {sourceLabel}
    </button>
  );
}

export default CopyFromFieldAction;
